import React, { ReactElement } from 'react';
import { Button, BUTTON_SIZE, BUTTON_STYLE_TYPE } from 'b2b-components/theme/components/Button';
import { Modal, MODAL_ANIMATION_TYPE, MODAL_CLOSE_BUTTON, MODAL_TYPE } from 'b2b-components/theme/components/Modal';
import { useTranslate } from 'b2b-apps/shop/i18n/hooks';
import { ComponentType, Props } from './';

const TermsModal: ComponentType = ({
  isOpen,
  modalContent,
  toggleModal,
}: Props): ReactElement => {
  const t = useTranslate();

  return (
    <Modal
      animationType={MODAL_ANIMATION_TYPE.fade}
      closeButton={MODAL_CLOSE_BUTTON.right}
      content={() => (
        <>
          <div
            className='Modal-Content'
            dangerouslySetInnerHTML={{
              __html: modalContent,
            }}
          />
          <div className="Modal-ButtonsWrapper">
            <Button
              className="Modal-ButtonDiscard"
              size={BUTTON_SIZE.small}
              styleType={BUTTON_STYLE_TYPE.light}
              onClick={toggleModal}
            >
              {t('Close')}
            </Button>
          </div>
        </>
      )}
      isOpen={isOpen}
      onCloseModal={toggleModal}
      type={MODAL_TYPE.default}
      text={{
        ariaLabel: t('Terms and conditions'),
        ariaCloseModal: t('Close'),
      }}
    />
  );
};

export { TermsModal };
